import { updateClinics, updateCurrentPosition } from "../FindClinicMap/find-clinic-map";
import { GeoLocation, getCurrentPosition } from "../Google/Maps/google-maps";
import { toggleFilterDropdownOption } from "../Shared/FilterDropdown/filter-dropdown";
import { initializeModal } from "../Shared/Modal/modal";
import { updateFormFilterFacets } from "../Shared/Utilities/filterFacets";

const clinicFinderForm = document.getElementById(
  "find-clinic-form"
) as HTMLFormElement | null;

if (!clinicFinderForm) {
  throw "Find clinic page clinicFinderForm missing";
}

const queryInput = clinicFinderForm.querySelector<HTMLInputElement>('[name="query"]');

const positionButton =
  clinicFinderForm.querySelector<HTMLElement>(`[data-position-button]`);

const sortSelect =
  clinicFinderForm.querySelector<HTMLSelectElement>('select[name="sort"]');

const geolocationFailedModal = clinicFinderForm.querySelector<HTMLElement>(
  "[data-geolocation-failed-modal]"
);

const latitudeInput =
  clinicFinderForm.querySelector<HTMLInputElement>('[name="latitude"]');

const longitudeInput =
  clinicFinderForm.querySelector<HTMLInputElement>('[name="longitude"]');

if (!positionButton) {
  throw "Find clinic page positionButton missing";
}
if (!queryInput) {
  throw "Find clinic page query input missing";
}
if (!geolocationFailedModal) {
  throw "Find clinic page geolocationFailedModal missing";
}
if (!latitudeInput) {
  throw "Find clinic page latitudeInput missing";
}
if (!longitudeInput) {
  throw "Find clinic page longitudeInput missing";
}

const mapId = "find-clinic-map";

let currentPosition: GeoLocation | undefined;

const geolocationFailedModalDefinition = initializeModal(geolocationFailedModal);

const filterDropdowns = Array.from(
  document.querySelectorAll<HTMLElement>("[data-filter-dropdown]")
);

filterDropdowns.forEach(filterDropdown => {
  if (filterDropdown.id === "fd-sort") {
    // Clicking the position button is the same as changing the sort order to nearest
    positionButton.addEventListener("click", () => {
      toggleFilterDropdownOption(filterDropdown, "Nearest");
    });
  }

  const select = filterDropdown.querySelector("select");

  if (select) {
    select.addEventListener("change", async _ => {
      // Update geolocation inputs if sorting on nearest
      try {
        if (select.name === "sort" && select.value === "Nearest") {
          currentPosition = await getCurrentPosition();

          latitudeInput.value = `${currentPosition.latitude}`;
          longitudeInput.value = `${currentPosition.longitude}`;
        }

        // Submit the form whenever a filter is updated
        clinicFinderForm.requestSubmit();
      } catch (e) {
        console.warn(e);

        geolocationFailedModalDefinition?.open();
      }
    });
  }
});

clinicFinderForm.addEventListener("htmx:afterOnLoad", async _ => {
  const updatedFilterFacetsElement = document.querySelector<HTMLElement>(
    "#find-clinic-search-results [data-facets-json]"
  );

  updateFormFilterFacets(clinicFinderForm, updatedFilterFacetsElement);

  await updateClinics(mapId);

  if (
    currentPosition &&
    currentPosition.latitude &&
    currentPosition.longitude &&
    sortSelect?.value === "Nearest"
  ) {
    await updateCurrentPosition(mapId, currentPosition);
  }
});
